'use memo';

import { Outlet, createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { FillScreen } from '@/components/Layout';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { DeviceAlertCategorySidebar } from './-components/DeviceAlertCategorySidebar';
import { useDeviceAssignmentAlertCountsQuery } from './-query';
import { useDeviceAlertCountsQuery } from './-query/deviceAlert';
import { DeviceAlertsSearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_staff/devices/_list/alerts/_alerts')({
  validateSearch: zodValidator(DeviceAlertsSearchSchema),
  component: RouteComponent
});
function RouteComponent() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.devices.alerts'
  });
  useDocumentTitle(t($ => $.pageTitle));
  const assignmentCountsQuery = useDeviceAssignmentAlertCountsQuery();
  const deviceAlertCountsQuery = useDeviceAlertCountsQuery();
  return <FillScreen className="flex min-h-0 overflow-hidden">
      <DeviceAlertCategorySidebar assignmentCounts={assignmentCountsQuery.isError ? undefined : assignmentCountsQuery.data} deviceAlertCounts={deviceAlertCountsQuery.isError ? undefined : deviceAlertCountsQuery.data} />
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
        <Outlet />
      </div>
    </FillScreen>;
}